import ScrollMagic from 'scrollmagic';
import RytmWebflow from 'rytm-webflow'

class OpeningController extends RytmWebflow.Controller {
  
  /**
  * on view Swap complete - just before SHOW
  * @param {Event} e
  **/
  onViewSwapComplete(e) {
    super.onViewSwapComplete(e);
    this.initScrollScene();
  }
  addEventListeners() {
    super.addEventListeners();
  }
  removeEventListeners() {
    super.removeEventListeners();
    this.destroyScrollScene();
  }
  

  initScrollScene() {
    if (this.sceneInited) {
      return false;
    }
    // scrollController 
    // RytmWebflow.scrollController;
    // console.log(RytmWebflow.scrollController);
    const container = document.querySelector(this.getContainerSelector());
    const img = container ? container.querySelector('.opening-bg-img') : null;
    if (!img) {
      return false;
    }
    this.smScene = new ScrollMagic.Scene({
      triggerElement: container,
      triggerHook: 0,
      duration: '100%'
    });
    this.smScene.setTween(img, {y: -200, ease: "none"});
    this.smScene.addTo(RytmWebflow.scrollController.get());
    this.sceneInited = true;
  }
  destroyScrollScene() {
    if (this.smScene) {
      this.smScene.destroy(true);
      this.smScene = null;
    }
    this.sceneInited = false;
  }

}

export default OpeningController;